import { TbArrowMerge } from "react-icons/tb";
import { Link, useParams } from "react-router-dom";
import { MdOutlineReviews } from "react-icons/md";
import { IoShareSocial } from "react-icons/io5";
import TabSelction from "./TabSelection";
import { useQuery } from "@tanstack/react-query";
import { getRestaurantById } from "../../../api/user/restaurants";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { useTranslation } from "../../../hooks/useTranslation";
import { RestaurantDetailDetailedLoading } from "../../../helper/lorder";

const RestaurantDetail = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { restaurantId, reservationId } = location.state || {};

  const { data, isLoading:restaurantLoading } = useQuery({
    queryKey: ["restaurant", restaurantId],
    queryFn: () => getRestaurantById(restaurantId),
    enabled: !!restaurantId,
  });

  const restaurant = data?.data;

  const handleOpenGoogleMaps = () => {
    if (!restaurant?.location?.coordinates?.length) {
      toast.error(t("restaurantDetail").locationError);
      return;
    }

    const [lng, lat] = restaurant.location.coordinates; // GeoJSON format [lng, lat]

    // Try to get current location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const myLat = position.coords.latitude;
          const myLng = position.coords.longitude;
          const mapsUrl = `https://www.google.com/maps/dir/${myLat},${myLng}/${lat},${lng}`;
          window.open(mapsUrl, "_blank");
        },
        () => {
          // If location denied → just show destination
          const mapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
          window.open(mapsUrl, "_blank");
        }
      );
    } else {
      // Geolocation not supported
      const mapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(mapsUrl, "_blank");
    }
  };

  const handleShare = () => {
    const shareUrl = `${window.location.origin}/restaurantordering`;
    navigator.clipboard.writeText(shareUrl).then(() => {
      toast.success(t("restaurantDetail").shareSuccess);
    });
  };

  return (
    <>
    {restaurantLoading?<RestaurantDetailDetailedLoading/>:<div className=" lg:pb-[100px] md:pb-[70px] pb-[30px]">
        <div className="container">
          {restaurant?.images && restaurant.images.length > 0 ? (
            <div className="grid grid-cols-1 lg:grid-cols-[605px_1fr] md:grid-cols-2 gap-[19px] mt-[36px] mb-[40px]">
              <div>
                <img
                  src={`${restaurant.images[0]}`}
                  alt="restaurant"
                  className="rounded-tl-[10px] rounded-bl-[10px] w-full h-full object-cover"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px]">
                {restaurant.images.slice(1, 5).map((image, index) => (
                  <div key={index}>
                    <img
                      src={`${image}`}
                      alt={`restaurant-${index}`}
                      className={`w-full h-full object-cover ${
                        index === 1 || index === 3
                          ? "rounded-tr-[10px] rounded-br-[10px]"
                          : ""
                      }`}
                    />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <p>{t("restaurantDetail").noImages}</p>
          )}
          <div className="grid grid-cols-1 lg:grid-cols-2 md:gap-[42px]  mt-[30px]">
            <div>
              <h2 className="md:text-[25px] text-[20px] font-semibold text-black mb-[10px] leading-[25px]">
                {restaurant?.name}
              </h2>
              <p className="text-lg text-black mb-5 leading-[22px]">
                {restaurant?.address}
              </p>
            </div>
            <div className="flex gap-[10px] md:justify-end">
              <button
                onClick={handleOpenGoogleMaps}
                className="flex justify-center items-center w-[36px] h-[36px] rounded-full border border-[#DDDDDD]"
              >
                <TbArrowMerge
                  size={22}
                  className="text-[#4CAF50] text-[25px]"
                />
              </button>
              {/* <Link
                to="#"
                className="flex justify-center items-center w-[36px] h-[36px] rounded-full border  border-[#DDDDDD]"
              >
                <MdOutlineReviews
                  size={22}
                  className="text-[#4CAF50] text-[25px]"
                />
              </Link> */}
              <button
                onClick={handleShare}
                className="flex justify-center items-center w-[36px] h-[36px] rounded-full border border-[#DDDDDD]"
              >
                <IoShareSocial
                  size={22}
                  className="text-[#4CAF50] text-[25px]"
                />
              </button>
            </div>
          </div>

          <TabSelction
            restaurantId={restaurantId}
            reservationId={reservationId}
            restaurant={restaurant}
          />
        </div>
      </div>}
    
      
    </>
  );
};

export default RestaurantDetail;
